import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import { IdeyaButton } from '../../../../common/antd/ideya-button.tsx'
import IdeyaTypography from '../../../../common/antd/ideya-typography.tsx'
import { PnlChart } from './charts/pnl-chart.tsx'
import { convertPxToNumber } from '../../../../utils/helpers.ts'
import { selectUser } from '../../../../features/user/user.slice.ts'
import { CumulativePnlChart } from './charts/cumulative-pnl-chart.tsx'
import { TopBottomPerformingIdeasChart } from './charts/top-bottom-performing-ideas-chart.tsx'
import { HitRateChart } from './charts/hit-rate-chart.tsx'
import { TotalNewIdeasChart } from './charts/total-new-ideas-chart.tsx'
import { useIsMobile } from '../../../../common/hooks/use-is-mobile.ts'
import Row from 'antd/es/grid/row'
import Col from 'antd/es/grid/col'
import { useTranslation } from 'react-i18next'
import { TopBottomPerformingIdeasMobileChart } from './charts/top-bottom-performing-ideas-chart-mobile.tsx'

interface DashboardComponentProps {
  bookId?: string
}

export const DashboardComponent: React.FC<DashboardComponentProps> = ({
  bookId,
}) => {
  const { t } = useTranslation()
  const themeStyle = useAppSelector(selectThemeStyle)
  const userInfo = useAppSelector(selectUser)
  const isMobile = useIsMobile(768)

  // Use provided bookId or fallback to userInfo.bookId
  const resolvedBookId = bookId ?? userInfo.bookId

  return (
    <>
      <Row
        justify={'space-between'}
        style={{
          display: 'flex',
          height: '44px',
          padding: '10px 16px',
          alignItems: 'center',
          alignContent: 'center',
          gap: '10px',
          alignSelf: 'stretch',
          borderRadius: '8px',
          border: '1px solid rgba(0, 0, 0, 0.14)',
          backgroundColor: themeStyle.myTitleBg,
        }}
      >
        <Col>
          <IdeyaTypography.Text size={'base'}>
            {t('dashboard.dashboard')}
          </IdeyaTypography.Text>
        </Col>
        <Col>
          <IdeyaButton
            ideyaType={'secondary'}
            style={{
              display: 'flex',
              padding: '0px 15px',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
              borderRadius: '16px',
              fontSize: '14px',
            }}
          >
            Edit
          </IdeyaButton>
        </Col>
      </Row>
      <Row
        style={{
          marginTop: themeStyle.marginBase,
          width: '100%',
          flexDirection: isMobile ? 'column' : 'row',
        }}
        gutter={[0, convertPxToNumber(themeStyle.marginBase)]}
      >
        <Col span={24} style={{ marginBottom: isMobile ? 16 : 0 }}>
          <PnlChart bookId={resolvedBookId} />
        </Col>
        <Col span={24} style={{ marginBottom: isMobile ? 16 : 0 }}>
          <CumulativePnlChart bookId={resolvedBookId} />
        </Col>
        <Col span={24} style={{ marginBottom: isMobile ? 16 : 0 }}>
          {isMobile ? <TopBottomPerformingIdeasMobileChart bookId={resolvedBookId}/> : <TopBottomPerformingIdeasChart bookId={resolvedBookId} />}
        </Col>
        <Row
          gutter={[
            convertPxToNumber(themeStyle.marginBase),
            convertPxToNumber(themeStyle.marginBase),
          ]}
          justify={'center'}
          style={{
            width: '100%',
            flexDirection: isMobile ? 'column' : 'row',
          }}
        >
          <Col
            span={isMobile ? 24 : 12}
            style={{ marginBottom: isMobile ? 16 : 0 }}
          >
            <HitRateChart bookId={resolvedBookId} />
          </Col>
          <Col
            span={isMobile ? 24 : 12}
            style={{ marginBottom: isMobile ? 16 : 0 }}
          >
            <TotalNewIdeasChart bookId={resolvedBookId} />
          </Col>
        </Row>
      </Row>
    </>
  )
}
